import React from 'react';
/* eslint-disable */
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';

function getUomLabel(measuringUnit) {
  const normalized = Number(measuringUnit);
  if (normalized === 1) return 'Unit';
  if (normalized === 2) return 'Kg';
  if (normalized === 3) return 'g';
  return '';
}

export default class ComponentToPrint extends React.Component {
  render() {
    const stockBalanceDetails = this.props.stockBalanceDetails || [];

    return (
      <div style={{ padding: '15px', display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: 1100 }}>
          <h3 style={{ textAlign: 'center', margin: 0 }}>
            <u>Stock Management</u>
          </h3>
          <Box style={{ marginTop: 12 }}>
            <TableContainer>
              <Table aria-label="stock-management-table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Product Category</TableCell>
                    <TableCell align="center">Product Code</TableCell>
                    <TableCell align="center">Product Name</TableCell>
                    <TableCell align="center">UOM</TableCell>
                    <TableCell align="center">Available Stock</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stockBalanceDetails.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell align="center">{row.productCategoryName}</TableCell>
                      <TableCell align="center">{row.productCode || row.skuCode || ''}</TableCell>
                      <TableCell align="center">{row.productName}</TableCell>
                      <TableCell align="center">{getUomLabel(row.measuringUnit)}</TableCell>
                      <TableCell align="center">
                        {row.availableQuantity !== undefined && row.availableQuantity !== null && row.availableQuantity !== ''
                          ? Number(row.availableQuantity).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                          : ''}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}

